// Global Fetch Wrapper - Automatically handles authentication
// Import this once in App.js to override global fetch

import { API_BASE } from '../api/index.js';

// Re-export API_BASE for consistency
export { API_BASE };

const originalFetch = window.fetch;

window.fetch = async function(url, options = {}) {
  // Only add auth headers for API calls to our backend
  const isApiCall = url.includes(API_BASE) || url.startsWith('/api');
  
  if (isApiCall) {
    const accessToken = localStorage.getItem('accessToken');
    
    if (accessToken) {
      options.headers = {
        ...options.headers,
        'Authorization': `Bearer ${accessToken}`
      };
    }
  }
  
  try {
    const response = await originalFetch(url, options);
    
    // Handle authentication errors for API calls
    if (isApiCall && response.status === 401) {
      console.error('Authentication failed - token may be expired');
      
      // Clear invalid tokens
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('user');
      
      // Show user-friendly message
      // alert('Your session has expired. Please login again.');
      
      // Redirect to login
      window.location.href = '/login';
    }
    
    return response;
  } catch (error) {
    console.error('Fetch error:', error);
    throw error;
  }
};

console.log('🔐 Global fetch wrapper initialized - all API calls will include authentication');

export default window.fetch;